module.exports = __webpack_public_path__ + "static/img/4.ed8e395.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/eng/4.png
// module id = 9Nw1
// module chunks = 0